import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const ReportTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  & th {
    width: 120px;
    background-color: ${ColorSF2.lightGray};
    font-size: 12px;
    font-weight: 100;
  }
  & td {
    padding: 5px;
    font-size: 12px;
  }
  & tr {
    border: 1px solid ${ColorSF2.mediumGray};
  }
  & th,
  td {
    border: 1px solid ${ColorSF2.mediumGray};
  }
`;
export const InputTitle = styled.div`
  flex: 0 0 auto;
`;
export const InputText = styled.input`
  ${props => props.width && `width: ${props.width}`};
  height: 23px;
  padding: 0px 4px;
  border: 1px solid ${ColorSF2.mediumGray};
`;
export const Tr = styled.tr`
  height: 40px;
`;
export const Td = styled.td`
  ${props => props.width && `width: ${props.width}`};
`;
export const ReportTableLabel = styled.span`
  font-size: 12px;
  color: ${ColorSF2.steelGray};
  font-weight: 100;
`;
